import bgMapSrc from '@assets/images/bg-map.jpg';
import { Stack } from 'component-library';
import { FC, PropsWithChildren } from 'react';

import { Footer } from '@/components';
import { ContainerWithSidebars } from '@/components/widgets/t/ContainerWithSidebars/ContainerWithSidebars';
import { useScreenSize } from '@/hooks/useScreenSize';
import { HackHubSpotChatButton } from '@/layout/hack-hubspot-chat-button';

export const NewProjectLayout: FC<PropsWithChildren> = ({ children }) => {
  const isLargeScreen = useScreenSize() === 'large';

  return (
    <>
      <HackHubSpotChatButton />
      <Stack
        className='bg-map-texture h-full min-h-screen justify-normal bg-cover md:justify-between'
        style={{ backgroundImage: `url(${bgMapSrc})` }}
      >
        <ContainerWithSidebars>
          {children}
          {isLargeScreen && <Footer variant='white' />}
        </ContainerWithSidebars>
      </Stack>
    </>
  );
};
